var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Shadow",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#E7F9F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.0798 32.9599H34.5198L34.1998 34.5599C34.0798 35.1999 34.4798 35.8399 35.1198 35.9599C35.1998 35.9599 35.2798 35.9999 35.3598 35.9999C35.9198 35.9999 36.3998 35.5999 36.5198 35.0399L36.9598 32.9599H39.9198L39.5998 34.5599C39.4798 35.1999 39.8798 35.8399 40.5198 35.9599C40.5998 35.9599 40.6798 35.9999 40.7598 35.9999C41.3198 35.9999 41.7998 35.5999 41.9198 35.0399L42.3598 32.9599H44.2398C44.8798 32.9599 45.4398 32.4399 45.4398 31.7599C45.4398 31.1199 44.9198 30.5599 44.2398 30.5599H42.7998L43.3198 28.0399H45.2398C45.8798 28.0399 46.4398 27.5199 46.4398 26.8399C46.4398 26.1999 45.9198 25.6399 45.2398 25.6399H43.7998L44.1198 24.0399C44.2398 23.3999 43.8398 22.7599 43.1998 22.6399C42.5598 22.5199 41.9198 22.9199 41.7998 23.5599L41.3598 25.6399H38.3998L38.7198 24.0399C38.8398 23.3999 38.4398 22.7599 37.7998 22.6399C37.1598 22.5199 36.5198 22.9199 36.3998 23.5599L35.9998 25.7199H34.1198C33.4798 25.7199 32.9198 26.2399 32.9198 26.9199C32.9198 27.5599 33.4398 28.1199 34.1198 28.1199H35.4798L34.9598 30.6399H33.0398C32.3998 30.6399 31.8398 31.1599 31.8398 31.8399C31.8798 32.4399 32.3998 32.9599 33.0798 32.9599ZM37.9598 28.0799H40.9198L40.3998 30.5999H37.4398L37.9598 28.0799Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.5999 32.0001C29.2399 32.0001 29.7999 31.4801 29.7999 30.8001V23.8001C29.7999 23.1601 29.2799 22.6001 28.5999 22.6001C27.9599 22.6001 27.3999 23.1201 27.3999 23.8001V30.8401C27.3999 31.4401 27.9599 32.0001 28.5999 32.0001Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.6001 36.0801C29.4175 36.0801 30.0801 35.4175 30.0801 34.6001C30.0801 33.7827 29.4175 33.1201 28.6001 33.1201C27.7827 33.1201 27.1201 33.7827 27.1201 34.6001C27.1201 35.4175 27.7827 36.0801 28.6001 36.0801Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.2002 36.0801C22.0176 36.0801 22.6802 35.4175 22.6802 34.6001C22.6802 33.7827 22.0176 33.1201 21.2002 33.1201C20.3828 33.1201 19.7202 33.7827 19.7202 34.6001C19.7202 35.4175 20.3828 36.0801 21.2002 36.0801Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.3998 26.68C19.0398 26.88 19.6798 26.56 19.8798 25.92C20.0798 25.32 20.7598 24.8 21.5998 25.04C22.0398 25.16 22.3998 25.52 22.5198 25.96C22.6398 26.36 22.5598 26.76 22.3598 27.12C22.1598 27.44 21.7998 27.68 21.3998 27.72C20.5998 27.84 19.9998 28.56 19.9998 29.4V30.8C19.9998 31.44 20.5198 32 21.1998 32C21.8798 32 22.3998 31.48 22.3998 30.8V29.92C23.1998 29.64 23.8798 29.12 24.3598 28.4C24.9598 27.52 25.1198 26.4 24.8398 25.36C24.5198 24.08 23.4798 23.08 22.2398 22.72C20.2798 22.2 18.3198 23.24 17.6798 25.16C17.4398 25.8 17.7598 26.48 18.3998 26.68Z",
    fill: "#05BC86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.8 18H14.2C13.56 18 13 18.52 13 19.2V39.48C13 40.12 13.52 40.68 14.2 40.68H19.2V45.72C19.2 46.2 19.48 46.6 19.92 46.8C20.08 46.88 20.24 46.88 20.4 46.88C20.68 46.88 20.96 46.76 21.2 46.56L27.6 40.64H49.8C50.44 40.64 51 40.12 51 39.44V19.2C51 18.56 50.48 18 49.8 18ZM48.64 38.28H27.12C26.84 38.28 26.52 38.4 26.32 38.6L21.56 43V39.48C21.56 38.84 21.04 38.28 20.36 38.28H15.36V20.4H48.6V38.28H48.64Z",
    fill: "#05BC86"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticIcon6);
export default __webpack_public_path__ + "static/media/StatisticIcon_6.b209181e5e205cabd74b89e5483c38eb.svg";
export { ForwardRef as ReactComponent };